import React, { useEffect, useState } from "react";
import { CodeViewer } from "./CodeViewer";

import { readmes } from "./readmes";
import { ProjectTabs } from "./ProjectTabs";
import { ProjectsIntro } from "./ProjectsIntro";

function FolderNode({ dir, childNode, onFileClick, setCurrentFile, depth }) {
  const [showChildren, setShowChildren] = useState(false);

  return (
    <li className={depth === 0 ? "truncate" : "truncate pl-3"}>
      <span
        className="cursor-pointer font-semibold"
        onClick={(e) => {
          e.stopPropagation();
          setShowChildren((s) => !s);
        }}
      >
        {dir}/
      </span>
      {showChildren && depth < 2 && (
        <RenderFileTree
          node={childNode}
          onFileClick={onFileClick}
          depth={depth + 1}
          setCurrentFile={setCurrentFile}
        />
      )}
    </li>
  );
}

function RenderFileTree({ node, onFileClick, setCurrentFile, depth = 0 }) {
  if (!node) return null;

  return (
    <ul>
      {node.files &&
        Object.entries(node.files).map(([file, content]) => (
          <li
            className={
              depth === 0
                ? "truncate cursor-pointer"
                : "truncate pl-3 cursor-pointer"
            }
            key={file}
            onClick={(e) => {
              e.stopPropagation();
              onFileClick(content.split("\n"));
              setCurrentFile && setCurrentFile(file);
            }}
          >
            {file}
          </li>
        ))}
      {node.children &&
        Object.entries(node.children).map(([dir, childNode]) => (
          <FolderNode
            key={dir}
            dir={dir}
            childNode={childNode}
            onFileClick={onFileClick}
            setCurrentFile={setCurrentFile}
            depth={depth}
          />
        ))}
    </ul>
  );
}

export const ProjectsContentCard = ({
  projectState,
  projectIdentifier,
  authenticatedResources,
  setCurrentFile,
  setProjectIdentifier,
}) => {
  const [contents, setContents] = useState(undefined);

  useEffect(() => {
    setContents(undefined);
    const container = document.getElementById("text-editor-container");
    if (container) container.scrollTop = 0;
  }, [projectIdentifier]);

  if (projectIdentifier == "Tutorial") {
    return (
      <ProjectsIntro
        authenticatedResources={authenticatedResources}
        setProjectIdentifier={setProjectIdentifier}
      />
    );
  }

  return (
    <div className="flex flex-row h-full font-sans">
      {/* FILE TREE */}
      <div className="w-1/4 flex-grow overflow-y-scroll bg-gray-50 text-sm p-1 pr-0 border-r text-gray-700 select-none h-full">
        <p
          className="font-semibold text-indigo-500 cursor-pointer"
          onClick={() => {
            setContents(undefined);
            setCurrentFile && setCurrentFile("README.md");
          }}
        >
          README.md
        </p>
        <RenderFileTree
          node={projectState}
          onFileClick={setContents}
          setCurrentFile={setCurrentFile}
        />
      </div>
      {/* PROJECT VIEW */}
      <div
        className="bg-white overflow-y-auto w-3/4 pb-6 h-full"
        id="text-editor-container"
      >
        {contents ? (
          <CodeViewer file={contents} />
        ) : (
          readmes[projectIdentifier](authenticatedResources)
        )}
      </div>
    </div>
  );
};
